import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBrandDy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={200}
    height={200}
    className="brand_dy_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}>
    <path
      fill="#111"
      d="M184.32 0h655.36Q1024 0 1024 184.32v655.36Q1024 1024 839.68 1024H184.32Q0 1024 0 839.68V184.32Q0 0 184.32 0"
    />
    <path
      fill="#FF4040"
      d="M204.278 670.597a246.25 246.25 0 0 1 245.975-245.975v147.579a98.5 98.5 0 0 0-98.386 98.386c0 48.343 26.143 100.352 83.548 100.352 3.82 0 93.553-.88 93.553-77.2V134.36h157.266a133.315 133.315 0 0 0 133.12 132.997l-.134 147.313a273.15 273.15 0 0 1-142.622-38.912l-.062 317.983c0 146.001-124.242 224.778-241.141 224.778-131.748.03-231.117-106.568-231.117-247.92"
    />
    <path
      fill="#00F5FF"
      d="M164.925 631.235A246.25 246.25 0 0 1 410.9 385.26v147.578a98.5 98.5 0 0 0-98.385 98.386c0 48.343 26.142 100.352 83.548 100.352 3.82 0 93.552-.88 93.552-77.199V94.997h157.266a133.315 133.315 0 0 0 133.12 132.997l-.133 147.312a273.15 273.15 0 0 1-142.623-38.912l-.061 317.983c0 146.002-124.242 224.778-241.142 224.778-131.748.03-231.117-106.567-231.117-247.92"
    />
    <path
      fill="#FFF"
      d="M410.91 427.581C252.089 447.734 126.465 650.301 256.8 832.584 377.2 931.062 630.487 873.789 637.5 660.726l-.174-324.147a280.73 280.73 0 0 0 142.89 38.625V261.222a145 145 0 0 1-72.807-54.825 135.24 135.24 0 0 1-54.702-72.458H529.039l-.082 561.418c-.112 78.47-130.97 106.415-164.188 30.26-83.19-39.773-64.379-190.925 46.316-192.574z"
    />
  </svg>
);
export default SvgBrandDy;
